import React from 'react';

import Link from 'Elements/Link';

const Home = () => (<div>
    <div>Home</div>
    <Link
      to={{
        type: 'PRACTITIONER_DASHBOARD',
      }}
    >
      Go to dashboard
    </Link>
  </div>
);

export default Home;
